(function () {
  var debugPrefix = '[MLP Redirect]';
  var redirectPath = '/maintenance';
  var guardClass = 'mlp-redirect-pending';
  var guardStyleId = 'mlp-redirect-guard';
  var guardTimeoutMs = 1500;

  var config = window.ondeck_optimizely_sdk || {};
  var sdkKey = config.sdkKey || '';
  var flagKey = 'mlp_maintenance_redirect';
  var siteDomain = (config.siteDomain || '').replace(/\/$/, '');
  var debugEnabled = Boolean(config.debug);

  // Debug function that only logs if debug is enabled
  var debugLog = function (message, meta) {
    if (!debugEnabled || !window.console || !window.console.log) {
      return;
    }

    if (typeof meta === 'undefined') {
      window.console.log(debugPrefix + ' ' + message);
      return;
    }

    window.console.log(debugPrefix + ' ' + message, meta);
  };

  var logError = function (message, err) {
    if (window.console && window.console.error) {
      window.console.error(debugPrefix + ' ' + message, err);
    }
  };

  // Hides page content temporarily, always clears it via timeout or once the Optimizely decision is received
  var ensureGuard = function () {
    if (window.__mlpRedirectGuard) {
      debugLog('Guard already active');
      return;
    }

    var style = document.createElement('style');
    style.id = guardStyleId;
    style.textContent = 'html.' + guardClass + ' body{visibility:hidden !important;}';
    document.head.appendChild(style);
    document.documentElement.classList.add(guardClass);

    window.__mlpRedirectGuard = {
      clear: clearGuard,
    };

    debugLog('Guard applied', { timeoutMs: guardTimeoutMs });

    setTimeout(function () {
      if (window.__mlpRedirectGuard && typeof window.__mlpRedirectGuard.clear === 'function') {
        debugLog('Guard timeout reached');
        window.__mlpRedirectGuard.clear();
      }
    }, guardTimeoutMs);
  };

  // Removes the temporary guard so the page becomes visible again
  var clearGuard = function () {
    document.documentElement.classList.remove(guardClass);
    var guardStyle = document.getElementById(guardStyleId);
    if (guardStyle && guardStyle.parentNode) {
      guardStyle.parentNode.removeChild(guardStyle);
    }
    debugLog('Guard cleared');
  };

  // Set a user ID
  var getOrCreateUserId = function () {
    var userID = window.Cookies && window.Cookies.get ? window.Cookies.get('odUID') : null;
    if (userID) {
      return userID;
    }

    userID = 'user_' + Math.random().toString(36).slice(2, 11) + '_' + Date.now();
    if (window.Cookies && window.Cookies.set) {
      window.Cookies.set('odUID', userID);
    }

    return userID;
  };

  ensureGuard();
  debugLog('Redirect check starting', {
    redirectPath: redirectPath,
    siteDomain: siteDomain,
    hasSdkKey: Boolean(sdkKey),
  });

  if (!window.optimizelySdk || !sdkKey) {
    debugLog('SDK unavailable, skipping redirect check');
    clearGuard();
    return;
  }

  try {
    // Init Optimizely SDK session
    var pollingConfigManager = window.optimizelySdk.createPollingProjectConfigManager({
      sdkKey: sdkKey,
    });
    var batchEventProcessor = window.optimizelySdk.createBatchEventProcessor();
    var odpManager = window.optimizelySdk.createOdpManager();

    var optimizely = window.optimizelySdk.createInstance({
      projectConfigManager: pollingConfigManager,
      eventProcessor: batchEventProcessor,
      odpManager: odpManager,
    });

    debugLog('Optimizely instance created');

    optimizely.onReady().then(function () {
      var user = optimizely.createUserContext(getOrCreateUserId());
      var decision = user.decide(flagKey);

      debugLog('Decision received', {
        enabled: Boolean(decision && decision.enabled),
        variationKey: decision && decision.variationKey,
        ruleKey: decision && decision.ruleKey,
      });

      if (decision && decision.enabled && redirectPath) {
        var target = siteDomain + redirectPath;
        if (window.location.pathname !== redirectPath) {
          // Using replace so landing page is not kept in browser history
          debugLog('Redirecting', { from: window.location.href, to: target });
          window.location.replace(target);
          return;
        }
      }

      clearGuard();
    }).catch(function (err) {
      logError('onReady error', err);
      clearGuard();
    });
  } catch (err) {
    logError('initialization error', err);
    clearGuard();
  }
}());
